import { render } from "./FormPageTemplate.vue?vue&type=template&id=ffbcadd4"
import script from "./FormPageTemplate.vue?vue&type=script&lang=js"
export * from "./FormPageTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/FormCustom/FormPageTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ffbcadd4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ffbcadd4', __exports__)) {
    console.log('reload')
    api.reload('ffbcadd4', __exports__)
  }
  
  module.hot.accept("./FormPageTemplate.vue?vue&type=template&id=ffbcadd4", () => {
    console.log('re-render')
    api.rerender('ffbcadd4', render)
  })

}


export default __exports__